import { type ReactNode, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthStore } from "@/stores/auth.store.js";
import { Sidebar } from "./Sidebar.js";
import { Topbar } from "./Topbar.js";
import { routeTitle } from "./nav.js";

/** Application chrome: dark sidebar + topbar + scrolling content area. */
export function AppShell({ children }: { children: ReactNode }) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuthStore();

  // Close the mobile drawer whenever the route changes.
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isMobile = () =>
    typeof window !== "undefined" && window.matchMedia("(max-width: 900px)").matches;

  const handleToggle = () => {
    if (isMobile()) setMobileOpen((o) => !o);
    else setCollapsed((c) => !c);
  };

  const handleLogout = () => {
    logout();
    void navigate("/login");
  };

  return (
    <div className="app-shell">
      <Sidebar collapsed={collapsed} mobileOpen={mobileOpen} onNavigate={() => setMobileOpen(false)} />
      <div
        className={`sidebar__overlay${mobileOpen ? " sidebar__overlay--open" : ""}`}
        onClick={() => setMobileOpen(false)}
        aria-hidden="true"
      />
      <div className="app-main">
        <Topbar
          title={routeTitle(location.pathname)}
          onToggleSidebar={handleToggle}
          onLogout={handleLogout}
        />
        <div className="content">
          <div className="content__inner">{children}</div>
        </div>
      </div>
    </div>
  );
}
